import React from "react";

import { LinkButton } from 'com-gyf-webcore-userinterfacecomponents';

import PanelPermisos from './PanelPermisos'

const PanelesPermisos = (props) => {
    let permissionPanels = props.permisos.map((permiso) => {
        return (
            <PanelPermisos
                permiso={permiso}
                
                deletePermiso={props.deletePermiso}
                selectProductoPermiso={props.selectProductoPermiso}
                selectCategoriaPermiso={props.selectCategoriaPermiso}
                selectProgramaPermiso={props.selectProgramaPermiso}
                addFuncion={props.addFuncion}
                removeFuncion={props.removeFuncion}
            />
        );
    });

    let text = (props.permisos.length > 0)
        ? "Agregar otro bloque de permisos y restricciones"
        : "Asignar permisos y restricciones especiales";

    return (
        <div>
            {props.permisos.length > 0 && <h3>Permisos y restricciones especiales</h3>}
            {permissionPanels}
            <LinkButton text={text} onClick={() => props.addPermiso()} />
        </div>
    );
}

export default PanelesPermisos;